import { CHANGED_INDEX, TOGGLED_FULLSCREEN } from "./types";

export function doChangeBlogIndexInView(nextIndex, shouldScrollOnChange) {
  return (dispatch, getState) => {
    const oldIndex = getState().interactiveMap.blogIndexInView;
    if (oldIndex === nextIndex) return;
    if (shouldScrollOnChange) scrollToBlogIndex(nextIndex - 1);
    dispatch({
      type: CHANGED_INDEX,
      payload: {
        nextIndex
      }
    });
  };
}

function scrollToBlogIndex(index) {
  const blogContainer = document.getElementById("blogs");
  const blogEntries = Array.from(blogContainer.children).slice(1);
  let targetOffset = blogEntries[index].offsetTop - window.innerHeight / 3;
  blogContainer.scrollTo({
    top: targetOffset,
    behavior: "smooth"
  });
}

export function doToggleFullscreen() {
  return dispatch => {
    dispatch({
      type: TOGGLED_FULLSCREEN
    });
  };
}

